/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DCardHeading from '../card/card-heading';
import styles from './card-link.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Card Link Heading.
 *
 * @element c4d-card-link-heading
 */
@customElement(`${c4dPrefix}-card-link-heading`)
class C4DCardLinkHeading extends C4DCardHeading {
  static get stableSelector() {
    return `${c4dPrefix}--card-link-heading`;
  }

  static styles = styles;
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCardLinkHeading;
